import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import moment from 'moment';
import {
  message,
  Drawer,
  Form,
  Button,
  Row,
  Col,
  Divider,
  Typography,
  DatePicker,
  Select,
  Input,
  Spin,
} from "antd";
import {
  DownloadOutlined,
  PlusCircleFilled,
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";

import DebounceSelect from "./../../DebounceSelect";
import useAxios from "./../../../CustomHooks/useAxios";
import ShowTable from "./ShowTable";
import Add from "./Add";
import PageLink1 from "./../../PageLink/Page"; //PageLink';
const { Text } = Typography;
const { Option } = Select;
const NoteParamSetting = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { axiosi } = useAxios();


  const [visibleAdd, setVisibleAdd] = useState(false);
  const user = useSelector((state) => state.loginReducer.user);

  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const [companyid, setCompanyid] = React.useState({
    value: user.agents[0].company_id,
    label: user.agents[0].gmcomname,
  });

  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [code,setCode] = useState('');
  const [name,setName] = useState('');
  const [paramType,setParamType] = useState('');

  const warning = (msg) => {
    messageApi.open({
      type: "warning",
      content: msg,
    });
  };
  const style = {
    //  background: 'rgb(178, 227, 156) none repeat scroll 0% 0%',
    display: "flex",
    flexDirection: "column",
    padding: "8px 0",
  };
  async function fetchCompanyList(company_name) {
    console.log("fetching user", company_name);
    const body = await axiosi.get("companies", {
      params: { company_name, pageSize: 100 },
    });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.company_name,
        value: user.id,
      }));
    } else {
      const a = [{ label: "---no data---", value: "" }];
      return a.map((i) => i);
    }
    // return axiosi.get('companies',{params:{company_name,pageSize:100}} ) // fetch('https://randomuser.me/api/?results=5')
    //   .then((body) =>
    //     body?.data?.rows.map((user) => ({
    //      label: user.company_name,
    //       value: user.id,
    //     })),
    //   );
  }
  const doSearch = async() => {
    try {

      console.log("before sdata");
      const sdata = {
        page,
        // pageSize: process,
        companyid: companyid?.value,
        code,
        name,
        paramType,
        t:Math.random()
      };
      console.log(sdata);
      const kq = await axiosi.get("note_param_setting", { params: sdata });
      const kqdata = await kq.data;
      if (kq.status !== 204) {
        setData(kq.data);
        // setDataSum(null);
        
        // setSttBegin((kq.data.page-1)*kq.data.pageSize +1)
        
        console.log("[CallLog-extens]:", kqdata);
      } else {
        console.log("[No Content] kq.data=", kq.data);
        setData(null);
        // setDataSum(null);
      }
    } catch (error) {
      console.log("[handleSearchCallLog]:", error);
      setData(null);
      // setDataSum(null);
    }
  };
  
  useEffect(() => {
    doSearch();
  }, [refresh,page]);
  const handleSearch=()=>{
    setPage(1);
    setRefresh((pre) => !pre);
  }
  return (
    <>
      {contextHolder}
      <Drawer
        title="Add"
        placement="right"
        onClose={() => setVisibleAdd(false)}
        visible={visibleAdd}
      >
        <Add
          setVisibleAdd={setVisibleAdd}
          setRefressSearch={setRefresh}
        />
      </Drawer>

      
      <div className="row searchbox">
            
            <div className="right">Search:</div>
            
            <div className="left">
              <Button
                onClick={() => setVisibleAdd(true)}
                icon={<PlusCircleFilled style={{ color: "#1890ff" }} />}
              >
                Add
              </Button>
              
            </div>
          </div>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className={`gutter-row ${hideItem} `} span={4}>
          <div style={style}>
            <Text>Company :</Text>
            <DebounceSelect
              showSearch={true}
              value={companyid}
              placeholder=""
              fetchOptions={fetchCompanyList}
              onChange={(newValue) => {
                setCompanyid(newValue);
              }}
              style={{ width: "100%" }}
            />
          </div>
        </Col>
        <Col className="gutter-row" span={4}>
          <div style={style}>
            <Text>Param Name :</Text>
            <Select
              value={paramType}
              style={{ width: "100%" }}
              onChange={(value) =>{ 
                console.log(value)
                setParamType(value)}}
            >
              <Option value="">All</Option>
              <Option value="tkNoteCategory">Ticket Note Category</Option>
              <Option value="tkNoteStatus">Ticket Note Status</Option>
              <Option value="obCallStatus">Outbound Call Status</Option>
              <Option value="obDataStatus">Outbound Data Status</Option>
            </Select>
          </div>
        </Col>
        <Col className="gutter-row" span={4}>
          <div style={style}>
            <Text>Code :</Text>
            <Input placeholder="Code" 
            onChange={(event)=>setCode(event.target.value)} 
            />
          </div>
        </Col>
        <Col className="gutter-row" span={4}>
          <div style={style}>
            <Text>Code Name :</Text>
            <Input placeholder="Code Name"
             onChange={(event)=>setName(event.target.value)}
              />
          </div>
        </Col>
        <Col className="gutter-row" span={4}>
          <div style={style}>
            <Text> &nbsp;</Text>
            <Button onClick={handleSearch}>Search</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
                
          {data ? (
            <ShowTable
              data={data.rows}
              setRefressSearch={setRefresh}
              // sttBegin={sttBegin}
              // sapxep={sapxep}
              // setSapxep={setSapxep}
            />
          ) : (
            <span></span>
          )}
        </Col>
        
      </Row>
      
      <Row>
        <Col span={24}>
          {data?.pages > 1 ? (
            <PageLink1
              pageSize={data.pageSize}
              searchpage={"calllog"}
              pages={data.pages}
              numrows={data.numrows}
              page={page}
              setPage={setPage}
            />
          ) : (
            <h1></h1>
          )}
        </Col>
      </Row>
      
    </>
  );
};

export default NoteParamSetting;
